import React from 'react';
import { Row } from 'react-bootstrap';

const Pulmonary = () => {
  return (
    <>
    <Row>
        <div className="col-xl-6">
          <div className="form-group">
            <label htmlFor="name" className="col-form-label">
              Service Details:
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Service Details"
              name="name"
            />
          </div>
        </div>
      </Row>
    </>
  )
}

export default Pulmonary